class virtualPlaying {
  constructor() {
    this.onDemandData = {};
    this.playMode = "normal";
    this.overlayRecoveryInProgress = false;

    setInterval(() => { this.checkIsPlaying(); }, 1000);
  }

  virtualCallback = (streamData) => {
    var callback = Object.values(streamData)[0];

    if (callback[0] == "closeOnDemand") {
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.querySelector("#player_ondemand").innerHTML = "";
      document.querySelector("#player_ondemand").classList.remove("small_video_playing");
      document.querySelector("#player_ondemand").classList.remove("center_video_playing");
      if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'block'; }
      localStorage.setItem("demo_video_num", "");
      if (window.refreshAllData) { window.refreshAllData(); }
      document.body.classList.remove("videoplay-playing");
    }

    if (callback[0] == "minimize") {
      document.querySelector("#player_ondemand").classList.add("small_video_playing");

      var element = document.querySelector("#player_ondemand video");
      element.muted = true;
      element.loop = true;
      element.autoplay = true;
      element.volume = "0";
    }

    if (callback[0] == "playVideo") {
      this.play();
    }
    if (callback[0] == "pauseVideo") {
      this.pause();
    }
    if (callback[0] == "stopVideo") {
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.querySelector("#player_ondemand").innerHTML = "";
      document.querySelector("#player_ondemand").classList.remove("small_video_playing");
      document.querySelector("#player_ondemand").classList.remove("center_video_playing");
      localStorage.setItem("demo_video_num", "");
      document.body.classList.remove("videoplay-playing");
    }

    if (callback[0] == "hide") {
      document.querySelector("#player_ondemand").classList.add("hide");
      var element = document.querySelector("#player_ondemand video");
      element.muted = true;
      element.volume = 0;
      this.stop();
      if (window.stopAudio) window.stopAudio();
      document.body.classList.remove("videoplay-playing");
    }

    if (callback[0] == "seekVideo") {
      this.seek(callback[1]);
    }

    if (callback[0] == "pauseTimeDemo") {
      this.pause();
      this.timePauseDemo = callback[1];
    }
    //console.log("got", callback);
  };

  startOnDemandStream = (streamData) => {
    document.body.classList = [];
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'none'; }

    let newStreamData = window.checkIsSelf();
    streamData = !newStreamData || newStreamData == 'no' ? streamData : newStreamData;

    this.onDemandData = JSON.parse(streamData);
    if (this.onDemandData && this.onDemandData["activities"]) {
      var img = new Image();
      for (var i = 0; i < this.onDemandData["activities"].length; i++) {
        img.src = this.onDemandData["activities"][i]["image"];
      }
    }
    this.lastDemoPaused = localStorage.getItem("demo_video_num");
    if (this.lastDemoPaused && this.timePauseDemo > 0) {
      setTimeout(() => {
        var portrait = localStorage.getItem("flutter.isPortraitAllowed") != null ? localStorage.getItem("flutter.isPortraitAllowed") : false;
        this.startVideoPlay(this.lastDemoPaused, portrait);
        document.querySelector("#player_ondemand video").currentTime = this.timePauseDemo;
        window.currentActiv(this.lastDemoPaused);
      }, 100);
    } else {
      var video = localStorage.getItem("flutter.firstUndone") != null ? localStorage.getItem("flutter.firstUndone") : 0;
      var portrait = localStorage.getItem("flutter.isPortraitAllowed") != null ? localStorage.getItem("flutter.isPortraitAllowed") : false;
      this.startVideoPlay(video, portrait);
    }
  };

  setOnDemandStream = (streamData) => {
    this.onDemandData = JSON.parse(streamData);
  };

  preloadDemandStream = (streamData) => {
    this.onDemandData = JSON.parse(streamData);

    let audioList = [];
    const acts = this.onDemandData?.activities ?? [];
    for (let i = 0; i < acts.length; i++) {
      if (acts[i].demo_video) {
        audioList.push(acts[i].demo_video.replace('.mp4', '.mp3?v=1.0').replace('virtual_demovideo/', 'virtual_demomp3/'));
      }
    }
    audioList = [...new Set(audioList)];

    // one-time unlock on first user gesture
    const _unlockOnce = () => {
      try {
        if (window.preloadMultipleAudios) { window.preloadMultipleAudios(audioList); }
      } catch { }
    };
    window.addEventListener("mousedown", _unlockOnce, { capture: true, once: true });
    window.addEventListener("touchstart", _unlockOnce, { capture: true, once: true });
  };

  startVideoPlay = (indexA, isPortraitAllowed) => {
    if (this.onDemandData && this.onDemandData["activities"] && this.onDemandData["activities"][indexA] && this.onDemandData["activities"][indexA]['show_demo'] == 1) {

      // var isPortraitAllowed = localStorage.getItem("flutter.isPortraitAllowed") != null ? localStorage.getItem("flutter.isPortraitAllowed") : false;

      var kIsWeb = localStorage.getItem("flutter.kIsWeb") != null ? localStorage.getItem("flutter.kIsWeb") : false;
      var videoToPlay = this.onDemandData["activities"][indexA]["demo_video"];

      if ((isPortraitAllowed == '"true"' || isPortraitAllowed == true) && kIsWeb == '"false"' && this.onDemandData["activities"][indexA]["portrait_video"] != null) {
        console.log('#Play portrait video');
        videoToPlay = this.onDemandData["activities"][indexA]["portrait_video"];
      }

      document.querySelector("#player_ondemand").innerHTML = `
		<video autoplay playsinline poster="`+ this.onDemandData["activities"][indexA]["image"] + `"><source src="` + videoToPlay + `" type="video/mp4"></video>
		`;
      this.play();
      document.querySelector("#player_ondemand video").ontimeupdate = this.updateVideoData;
      document.querySelector("#player_ondemand video").onloadedmetadata = this.updateVideoData;
    }
    localStorage.setItem("demo_video_num", indexA);

    window.virtualDemoPlay = this;
  };

  loadMp3WithRetry = async (url, offset = 0, retries = 3, delay = 500) => {
    const audioPlayer = window.audioPlayer;
    if (!audioPlayer || !audioPlayer.unlocked) {
      console.warn("WebAudio not unlocked, attempting to unlock");
      if (window.initFromUserGesture) {
        window.initFromUserGesture();
        // Waiting a bit for context to initialize
        await new Promise(r => setTimeout(r, 200));
      } else {
        throw new Error("WebAudio not unlocked");
      }
    }

    // first Ensureing context is running
    if (audioPlayer.ensureCtxRunning) {
      await audioPlayer.ensureCtxRunning();
    }


    for (let attempt = 1; attempt <= retries; attempt++) {
      try {
        const result = await audioPlayer.playAudioAt(url, offset);

        if (result && result.success) {
          return result; // return scheduling info
        }

        // If we get here, something went wrong
        if (attempt < retries) {
          console.log(`Retry attempt ${attempt + 1}/${retries} for ${url}`);
          await new Promise(r => setTimeout(r, delay * attempt)); // Exponential backoff
        }

      } catch (err) {
        console.warn(`MP3 attempt ${attempt} failed`, err);

        if (attempt < retries) {
          const backoffDelay = delay * Math.pow(1.5, attempt - 1); // Progressive delay
          await new Promise(r => setTimeout(r, backoffDelay));
        }
      }
    }

    // alert("MP3 failed after retries:" + url);

    console.error(`MP3 failed after ${retries} retries:`, url);
    throw new Error("MP3 failed after retries");
  };




  startRepVideoPlay = (video) => {
    console.log('Called for start rep video play: ', video);
    document.querySelector("#player_ondemand").innerHTML = '<video><source src="' + video + '" type="video/mp4"></video>';
    this.play();
    document.querySelector("#player_ondemand video").ontimeupdate = this.updateVideoData;
    document.querySelector("#player_ondemand video").onloadedmetadata = this.updateVideoData;
  };

  clearDemoVideoNum = () => {
    localStorage.setItem("demo_video_num", "");
  };

  play = async () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    document.body.classList.add("videoplay-playing");

    document.querySelector("#player_ondemand").classList.remove("hide");

    //  Always reset playMode at the start of every play() call.
    // straight to  MP3 path even when normal audio would work fine.

    this.playMode = "normal";
    this.overlayAudioActive = false;

    // Stopping any leftover overlay audio from a previous video
    if (this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioUrl = null;
    }

    let normalPlaySucceeded = false;

    try {
      // Step 1: Start muted to satisfy Safari autoplay rules
      video.muted = true;
      video.volume = 0;
      await video.play();
      console.log('✅ Muted autoplay succeeded');

      // Step 2: Try to unmute and play again
      video.muted = false;
      video.volume = 1;
      await video.play();
      console.log('✅ Unmuted playback works');
      this.playMode = "normal";
      normalPlaySucceeded = true;

      // Some of the  browsers (Android WebView, some iOS) resolve play() successfully
      // but silently ignore the unmute and then video.muted stays true.
      // If it happened, we  fall through to overlay mode.

      if (video.muted) {
        console.warn('Unmuted play resolved but video is still muted, forcing overlay');
        this.playMode = "overlay";
      } else {
        console.log('Unmuted playback confirmed');
        this.playMode = "normal";
        normalPlaySucceeded = true;
      }
    } catch (e) {
      console.warn('❌ Playback blocked until user interacts', e);
      video.muted = true;
      video.volume = 0;
      this.playMode = "overlay";
    }
    // if normal succed return early to avoid running the overlay fallback logic
    if (normalPlaySucceeded) {
      if (window.getLastPickedSpeaker?.()) {
        try {
          video.setSinkId(window.getLastPickedSpeaker()["deviceId"]);
        } catch (err) {
          console.warn("setSinkId failed", err);
        }
      }
      return;
    }

    // This will be reached only if success play unmuted
    if (this.playMode === "overlay") {
      try {
        video.pause();

        const offset = video.currentTime;

        // Getting the video source first -> which more reliably
        const videoSrc = video.querySelector('source')?.src || video.src || '';
        if (!videoSrc) {
          console.warn("No video source found");
          await video.play().catch(() => { });
          return;
        }

        // let mp3Url = video.querySelector('source')?.src || '';
        // mp3Url = mp3Url
        //   .replace('.mp4', '.mp3?v=1.0')
        //   .replace('virtual_demovideo/', 'virtual_demomp3/');

        // Convert to MP3 URL with multiple fallback patterns
        let mp3Url = videoSrc
          .replace('.mp4', '.mp3?v=1.0')
          .replace('.MP4', '.mp3?v=1.0')
          .replace('virtual_demovideo/', 'virtual_demomp3/');


        if (!mp3Url) {
          console.warn("No MP3 URL could be derived — overlay audio unavailable");
          // resumeing the muted video so the user sees something
          await video.play().catch(() => { });
          return;
        }

        if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
          window.audioPlayer.stopAudio(this.overlayAudioUrl);
          this.overlayAudioActive = false;
        }
        console.log("OVERLAY MODE STARTED", {
          videoSrc: video.querySelector('source')?.src || video.src,
          currentTime: video.currentTime,
          muted: video.muted,
          mp3Url: mp3Url
        });


        const result = await this.loadMp3WithRetry(mp3Url, offset, 3, 500);

        if (!result || !result.success) {
          console.warn("MP3 failed completely");
          await video.play().catch(() => { });
          return;
        }

        //  Clearing any pending recovery flags
        this.overlayRecoveryInProgress = false;

        // Setting these BEFORE awaiting the delay so checkIsPlaying
        // can see the state correctly if it fires during the wait
        this.overlayAudioActive = true;
        this.overlayAudioUrl = mp3Url;

        const ctx = window.audioPlayer.ctx;
        const startAt = result.scheduledTime;

        video.currentTime = offset;

        let delayMs = (startAt - ctx.currentTime) * 1000;
        if (delayMs < 0) delayMs = 0;

        await new Promise(resolve => setTimeout(resolve, delayMs));
        await video.play();

      } catch (err) {
        console.warn("Overlay MP3 setup failed — playing muted video as fallback", err);
        this.overlayAudioActive = false;
        this.overlayAudioUrl = null;
        await video.play().catch(() => { });
        console.warn("Overlay MP3 failed:", err);
        return;
      }
    }


    // Optional: restore audio output to specific speaker if available
    if (window.getLastPickedSpeaker !== undefined && window.getLastPickedSpeaker()) {
      try {
        video.setSinkId(window.getLastPickedSpeaker()["deviceId"]);
      } catch (err) {
        console.warn('setSinkId failed', err);
      }
    }
  };

  pause = () => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    video.pause();

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioActive = false;
    }
  };

  stop = () => {
    document.body.classList.remove("videoplay-playing");

    const video = document.querySelector("#player_ondemand video");
    if (!video) return;
    video.pause();
    video.currentTime = 0;

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      window.audioPlayer.stopAudio(this.overlayAudioUrl);
      this.overlayAudioActive = false;
    }
  };

  seek = async (seek_val) => {
    const video = document.querySelector("#player_ondemand video");
    if (!video) return;

    video.pause();

    // Always set the visual position immediately
    video.currentTime = seek_val;

    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      // Stop any previously playing overlay audio
      window.audioPlayer.stopAudio(this.overlayAudioUrl);

      const result = await this.loadMp3WithRetry(this.overlayAudioUrl, seek_val, 2, 400);
      if (!result?.success) return;

      const ctx = window.audioPlayer.ctx;
      const startAt = result.scheduledTime;

      let delayMs = (startAt - ctx.currentTime) * 1000;
      if (delayMs < 0) delayMs = 0;

      await new Promise(resolve => setTimeout(resolve, delayMs));
    }

    await video.play();
  };

  updateVideoData = () => {
    if (document.querySelector("#player_ondemand video") && window.flutter_OnDemand) {
      window.flutter_OnDemand(
        JSON.stringify({
          method: "videoProgress",
          timeElapsed: document.querySelector("#player_ondemand video").currentTime,
          duration: document.querySelector("#player_ondemand video").duration,
        })
      );
    }
  };

  setFullScreen = () => {
    document.querySelector("#player_ondemand").classList.remove("small_video_playing");
    document.querySelector("#player_ondemand").classList.remove("hide");
    var element = document.querySelector("#player_ondemand video");
    element.muted = false;
    element.loop = false;
    element.autoplay = true;
  };

  checkIsPlaying = async () => {
    const video = document.querySelector("#player_ondemand video");

    // 1️ If no video element → hard stop audio
    if (!video) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    // 2️ If video paused → stop audio
    if (video.paused) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    // 3️ If video unmuted → stop overlay (normal mode resumed)
    if (!video.muted) {
      if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
        window.audioPlayer.stopAudio(this.overlayAudioUrl);
        this.overlayAudioActive = false;
      }
      return;
    }

    // 4️ Overlay mode health check
    if (this.overlayAudioActive && this.overlayAudioUrl && window.audioPlayer) {
      const isPlaying = window.audioPlayer.isAudioPlaying(this.overlayAudioUrl);

      if (!isPlaying && !this.overlayRecoveryInProgress && video.muted) {
        this.overlayRecoveryInProgress = true;
        //  Don't recover immediately - waiting a bit to see if audio starts on its own (it often does after a seek or brief pause)
        setTimeout(async () => {
          try {
            const offset = video.currentTime;
            await this.loadMp3WithRetry(this.overlayAudioUrl, offset, 2, 300);
          } catch (err) {
            console.warn("Overlay recovery failed", err);
          }
        }, 300);

        setTimeout(() => {
          this.overlayRecoveryInProgress = false;
        }, 1500);
      }
    }
  };


  hideSupportHelp = () => {
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'none'; }
  }

  showSupportHelp = () => {
    if (document.querySelector("iframe#launcher")) { document.querySelector("iframe#launcher").style.display = 'block'; }
  }

  listenNative = () => {
    window.hideSupportHelp = this.hideSupportHelp;
    window.showSupportHelp = this.showSupportHelp;

    window.virtualCallback = this.virtualCallback;
    window.startOnDemandStream = this.startOnDemandStream;
    window.setOnDemandStream = this.setOnDemandStream;
    window.setFullScreen = this.setFullScreen;
    window.startVideoPlay = this.startVideoPlay;
    window.startRepVideoPlay = this.startRepVideoPlay;
    window.clearDemoVideoNum = this.clearDemoVideoNum;

    window.preloadDemandStream = this.preloadDemandStream;
  };
}

export default virtualPlaying;
